export default __webpack_public_path__ + "static/media/userm-3.b8ee455f.jpg";